import dataApi from "@/api/dataApi";
import bankApi from "@/api/bankApi";
const predialAPI = () => {
    const listaCargas = async ( ) => {
        const { data } = await dataApi.get(
            'predial.listaCargas',
            {
                params: {  }
            }
        ).catch(error => {
            console.log("Error al llamar a /listaCargas" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const errorList = async (idCarga ) => {
        const { data } = await dataApi.get(
            'predial.getErrorList',
            {
                params: { idCarga }
            }
        ).catch(error => {
            console.log("Error al llamar a /getErrorList" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const listaConciliacionCarga = async ( ) => {
        const { data } = await dataApi.get(
            'predial.listaConciliacionCarga',
            {
                params: {  }
            }
        ).catch(error => {
            console.log("Error al llamar a /listaConciliacionCarga" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const conciliacionMsgList = async (idConciliacion ) => {
        const { data } = await dataApi.get(
            'predial.getConciliacionMsgList',
            {
                params: { idConciliacion }
            }
        ).catch(error => {
            console.log("Error al llamar a /conciliacionMsgList" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const getExpediente = async (expediente ) => {
        const { data } = await dataApi.get(
            'predial.getExpediente',
            {
                params: { expediente }
            }
        ).catch(error => {
            console.log("Error al llamar a /getExpediente" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const redirectBanco =  async (expediente) => {
        const { data } = await bankApi.post(
            'post',null,
            {
                params: {expediente }
            }
        ).then(function (response) {
            //REDIRECT TERE
            console.log("By redirect!")
          //  window.location = "https://httpbin.org/post"; 
          }
        ).catch(error => {
            console.log("Error al llamar a /Banco Payment" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const getSignature = async (mp_order,mp_reference, mp_amount ) => {
        const { data } = await dataApi.get(
            'multipagos.getSignature',
            {
                params: { mp_order,mp_reference, mp_amount }
            }
        ).catch(error => {
            console.log("Error al llamar a /getSignature" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }

    const generaOrden =  async (expediente, numCarga) => {
        const { data } = await dataApi.post(
            '/predial.generaOrden',null,
            {
                params: {expediente, numCarga}
            }
        ).catch(error => {
            console.log("Error al llamar a /predial.generaOrden" )
            console.log(error)
            return { ok: false, message: "Telecomm issue" }
        })
        return data;
    }


    return {
        listaCargas,errorList,getExpediente,redirectBanco,getSignature,generaOrden,listaConciliacionCarga,conciliacionMsgList
   }

}

export default predialAPI